import script from "./IntakeTagBar.vue?vue&type=script&setup=true&lang=js"
export * from "./IntakeTagBar.vue?vue&type=script&setup=true&lang=js"

import "./IntakeTagBar.vue?vue&type=style&index=0&id=1a6608e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a6608e4"]])

export default __exports__